import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces/api-response.interface';
import { IData } from '../interfaces/data.interface';
import { environment } from 'src/environments/environment';
import { ICompanyData } from '../interfaces/company-data-interface';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(private readonly _http: HttpClient) { }

  //TODO: este metodo no se esta usando, la info de empresa no es dinamica
  getData(): Observable<ApiResponse<IData[]>> {
    return this._http.get<ApiResponse<IData[]>>(`${environment.apiUrl}/data`);
  }
  getCompanyData(): Observable<ApiResponse<ICompanyData>> {
    return this._http.get<ApiResponse<ICompanyData>>(`${environment.apiUrl}/data/company-data`);
  }
  getByType(type: string): Observable<ApiResponse<IData>> {
    return this._http.get<ApiResponse<IData>>(`${environment.apiUrl}/data/${type}`);
  }
  addData(data:IData): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(`${environment.apiUrl}/data/add`, data);
  }
  editData(data:IData): Observable<ApiResponse<any>> {
    return this._http.put<ApiResponse<any>>(`${environment.apiUrl}/data/${data.id}`, data);
  }
}
